import { Component } from 'react';
import './custom.css'
import { LoyaltyOffer } from './components/LoyaltyOffer'
import { Message } from './components/Message';
import { OneOffScanCode } from './components/OneOffScanCode';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ReceiptsForBusiness } from './components/ReceiptsForBusiness';
import { Tills } from './components/Tills';
import { Logon } from './components/Logon'
import { LoyaltyOffers } from './components/LoyaltyOffers'
import { Voucher } from './components/Voucher';
import { ChangePassword } from './components/ChangePassword';
import { ReviewRequestTemplate } from './components/ReviewRequestTemplate';
import { Business } from './components/Business';
import { ResetPassword } from './components/ResetPassword';
import { ForgotPassword } from './components/ForgotPassword';
import { Register } from './components/Register';
import { AddExistingUserToBusiness } from './components/AddExistingUserToBusiness';
import { AddNewUserBusiness } from './components/AddNewUserToBusiness';
import { DisableUsers } from './components/DisableUsers';
import { Reviews } from './components/Reviews';
import { ContactRequests } from './components/ContactRequests';
import { EasyTest } from './components/EasyTest';



export default class App extends Component {
    static displayName = App.name;

    render() {
        return (
            <BrowserRouter>
                <Routes>
                    <Route path='/message' element={<Message />} />
                    <Route path='/voucher' element={<Voucher />}/>
                    <Route path='/loyaltyoffer' element={<LoyaltyOffer />} />
                    <Route path='/receiptsforbusiness' element={<ReceiptsForBusiness />}/>
                    <Route path='/tills' element={<Tills />}/>
                    <Route path='/loyaltyoffers' element={<LoyaltyOffers />} />
                    <Route path='/logon' element={ <Logon />} />
                    <Route path='/changepassword' element={<ChangePassword />} />
                    <Route path='/reviewrequesttemplate' element={<ReviewRequestTemplate />} />
                    <Route path='/business' element={<Business />} />
                    <Route path='/resetpassword' element={<ResetPassword />} />
                    <Route path='/forgotpassword' element={<ForgotPassword /> } />
                    <Route path='/register' element={<Register />} />
                    <Route path='/addexistinguser' element={<AddExistingUserToBusiness />} />
                    <Route path='/addnewuser' element={<AddNewUserBusiness />} />
                    <Route path='/disableusers' element={<DisableUsers />} />
                    <Route path='/reviews' element={<Reviews />} />
                    <Route path='/contactrequests' element={<ContactRequests />} />
                    <Route path='/easytest' element={<EasyTest/> } />
                    <Route path='/' element={<OneOffScanCode />} />
                </Routes>
            </BrowserRouter>
        );
    }
}
